import req from "../http";

const userPermission = {
  // 取得 人員權限
  getUserPermission(guid) {
    return req("get", `/auth/user/menu/permission/${guid}`);
  },

};

export default userPermission;